import React, { useState } from 'react'
import { useForm, usePage } from '@inertiajs/inertia-react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import PaginationList from '../../Shared/Components/PaginationList'
import AlertDismissible from '../../Shared/Components/AlertDismissible'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import axios from 'axios'
import { SIA_NAVY } from '../../constants/siaTheme'
import { HistoryModal, formatDate } from './Records'

const CobranzaBitacora = ({ entries, filters, offices, advisers, canExport, canViewLog }) => {
    const { flash } = usePage().props
    const filterForm = useForm({
        search: filters.search || '',
        office_id: filters.office_id || '',
        adviser_id: filters.adviser_id || '',
    })
    const [history, setHistory] = useState({ show: false, logs: [], policy: '' })

    const submitFilters = (e) => {
        e.preventDefault()
        filterForm.get(route('cobranza.bitacora.index'), { preserveState: true })
    }

    const openHistory = async (row) => {
        const { data } = await axios.get(route('cobranza.follow-up.history', row.insurance_policy_id))
        setHistory({ show: true, logs: data.logs || [], policy: row.policy })
    }

    const rows = entries.data || []

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath="admin/cobranza/bitacora" />
            </span>

            <div
                className="rounded-2 mb-8 py-4 px-4 text-center text-white text-uppercase fw-bold fs-4"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.04em' }}
            >
                Panel de bitácora de cobranza
            </div>

            <div className="card card-flush shadow-sm mb-8">
                <div className="card-body py-8 px-6">
                    <Form onSubmit={submitFilters} className="row g-4 align-items-end">
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Oficina</Form.Label>
                            <Form.Select
                                className="form-select-solid"
                                value={filterForm.data.office_id}
                                onChange={(e) => filterForm.setData('office_id', e.target.value)}
                            >
                                <option value="">Todas</option>
                                {offices.map((o) => <option key={o.id} value={o.id}>{o.nombre}</option>)}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Asesor</Form.Label>
                            <Form.Select
                                className="form-select-solid"
                                value={filterForm.data.adviser_id}
                                onChange={(e) => filterForm.setData('adviser_id', e.target.value)}
                            >
                                <option value="">Todos</option>
                                {advisers.map((a) => <option key={a.id} value={a.id}>{a.display_name}</option>)}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Buscar</Form.Label>
                            <Form.Control
                                className="form-control-solid"
                                value={filterForm.data.search}
                                onChange={(e) => filterForm.setData('search', e.target.value)}
                                placeholder="Póliza, asegurado…"
                            />
                        </Col>
                        <Col md={3}>
                            <Button
                                type="submit"
                                disabled={filterForm.processing}
                                style={{ backgroundColor: SIA_NAVY, borderColor: SIA_NAVY }}
                            >
                                Filtrar
                            </Button>
                        </Col>
                    </Form>
                </div>
            </div>

            <div className="card card-flush shadow-sm">
                <div className="card-header border-0 pt-6 flex-wrap gap-3">
                    <h3 className="card-title fw-bold text-gray-800">Resultados</h3>
                    <div className="card-toolbar">
                        {canExport && (
                            <a className="btn btn-sm btn-light-primary" href={route('cobranza.bitacora.export', filterForm.data)}>
                                <i className="bi bi-file-earmark-excel me-1" />
                                Excel
                            </a>
                        )}
                    </div>
                </div>
                <div className="card-body pt-0">
                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-4">
                            <thead>
                                <tr className="fw-bold text-muted text-uppercase fs-7 bg-light">
                                    <th className="min-w-100px ps-4 rounded-start">Fecha</th>
                                    <th className="min-w-120px">Contactó</th>
                                    <th className="min-w-110px">Póliza</th>
                                    <th className="min-w-100px">Oficina</th>
                                    <th className="min-w-160px">Asegurado</th>
                                    <th className="min-w-100px">Teléfono</th>
                                    <th className="min-w-120px">Asesor</th>
                                    <th className="min-w-120px">Tipo de contacto</th>
                                    <th className="min-w-90px">¿Respondió?</th>
                                    <th className="min-w-90px text-end pe-4 rounded-end">Historial</th>
                                </tr>
                            </thead>
                            <tbody className="fs-7">
                                {rows.length === 0 ? (
                                    <tr>
                                        <td colSpan={10} className="text-center text-muted py-10">
                                            No hay registros para los filtros seleccionados.
                                        </td>
                                    </tr>
                                ) : (
                                    rows.map((row) => (
                                        <tr key={row.id}>
                                            <td className="ps-4 text-gray-800">{formatDate(row.contact_date)}</td>
                                            <td className="text-gray-800">{row.contacted_by || '—'}</td>
                                            <td className="text-gray-800">{row.policy || '—'}</td>
                                            <td className="text-gray-700">{row.office_name || '—'}</td>
                                            <td className="fw-semibold text-gray-800">{row.insured_name || '—'}</td>
                                            <td className="text-gray-700">{row.phone || '—'}</td>
                                            <td className="text-gray-800">{row.adviser_name || '—'}</td>
                                            <td className="text-gray-700">{row.contact_type || '—'}</td>
                                            <td className="text-gray-800">{row.responded || '—'}</td>
                                            <td className="text-end pe-4">
                                                {canViewLog && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-icon btn-light-primary"
                                                        title="Ver historial"
                                                        onClick={() => openHistory(row)}
                                                    >
                                                        <i className="bi bi-list-ul" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex justify-content-center py-6">
                        <PaginationList links={entries.links} filters={filterForm.data} />
                    </div>
                </div>
            </div>

            <HistoryModal
                show={history.show}
                onHide={() => setHistory({ show: false, logs: [], policy: '' })}
                logs={history.logs}
                policyNumber={history.policy}
            />
        </Row>
    )
}

CobranzaBitacora.layout = (page) => <Layout title="Bitácora Cobranza">{page}</Layout>

export default CobranzaBitacora
